/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryResponse, UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserPathParams } from "../models/UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUser";

function getUsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserUrl(userId: UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserPathParams["userId"]) {
  const res = { method: 'GET', url: `/admin/user/${userId}/permissions` as const }  
  return res
}

/**
 * @summary Get all permissions for a specific user
 * {@link /admin/user/:userId/permissions}
 */
export async function usersAuthzAPIAdminPermissionsReadGetPermissionsOfUser(userId: UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserPathParams["userId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getUsersAuthzAPIAdminPermissionsReadGetPermissionsOfUserUrl(userId).url.toString(), ... requestConfig })  
  return res.data
}